import { render, staticRenderFns } from "./PlatformMainMenu.vue?vue&type=template&id=5dd3665f&scoped=true"
import script from "./PlatformMainMenu.vue?vue&type=script&lang=js"
export * from "./PlatformMainMenu.vue?vue&type=script&lang=js"
import style0 from "./PlatformMainMenu.vue?vue&type=style&index=0&id=5dd3665f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd3665f",
  null
  
)

export default component.exports